import * as angular from 'angular';

"use strict";
angular.module('CustomerCtrl', []);

export default 'CustomerCtrl'
